import axios from "axios";
axios.defaults.timeout = 100000;
axios.defaults.withCredentials = true;
axios.defaults.retryDelay = 2000;
import router from "../router";
import { Message } from 'element-ui';
// axios.defaults.baseURL = "/";

// 请求的地方设置1
axios.interceptors.request.use(function (config) {
    // config.headers = { 'X-Requested-With': 'XMLHttpRequest' }
    var uploadAvator = config.url.indexOf('uploadAvator')
    var convertdate = config.url.indexOf('convertdate')
    if (uploadAvator != -1 || convertdate != -1) {
        config.headers = { 'content-type': 'application/x-www-form-urlencoded' };
    }
    return config; //添加这一行
});
// 响应的地方设置
axios.interceptors.response.use(function (config) {
    if (config.data.code == 3 && config.data.msg == '参数错误') {
        Message({
            message: '未知错误!',
            type: "warning"
        });
        // router.push("/family");
    } else if (config.data.code == -100) {
        if (window.location.hash.split('#')[1] != '/') {
            Message({
                message: '请重新登录!',
                type: "warning"
            });
            router.push("/");
        }
    } else if (config.data.code != 0) {
        Message({
            message: config.data.msg,
            type: "warning"
        });
    }
    return config;
}, (error) => {
    Message({
        message: '未知错误!',
        type: "warning"
    });
    return Promise.reject(error);
});

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get (url, params = {}) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params: params
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post (url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch (url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put (url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}



// WEBPACK FOOTER //
// ./src/request/http.js